import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { Lotus } from "./Lotus";
import { BRAND, NAV_LINKS, whatsappLink } from "../../data";

const scrollTo = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth" });
};

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <nav
      data-testid="main-nav"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-[#151c0f]/85 backdrop-blur-xl border-b border-[#b89d62]/20 py-3"
          : "bg-transparent py-6"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between">
        <button
          data-testid="nav-logo"
          onClick={() => scrollTo("home")}
          className="flex items-center gap-3 group"
        >
          <Lotus className="w-8 h-6 text-[#b89d62] transition-transform duration-500 group-hover:-translate-y-0.5" />
          <span className="font-serif-display text-2xl tracking-[0.25em] text-[#faf9f6] font-light">
            {BRAND.name}
          </span>
        </button>

        <div className="hidden lg:flex items-center gap-9">
          {NAV_LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-link-${l.id}`}
              onClick={() => scrollTo(l.id)}
              className="nav-link eyebrow !text-[#c9d3ca] hover:!text-[#b89d62]"
            >
              {l.label}
            </button>
          ))}
        </div>

        <a
          data-testid="nav-whatsapp-cta"
          href={whatsappLink()}
          target="_blank"
          rel="noopener noreferrer"
          className="hidden sm:inline-flex items-center gap-2 border border-[#b89d62] text-[#b89d62] hover:bg-[#b89d62] hover:text-[#151c0f] transition-all duration-400 px-5 py-2.5 rounded-none btn-label"
        >
          Book on WhatsApp
        </a>

        <button
          data-testid="mobile-menu-toggle"
          onClick={() => setOpen((v) => !v)}
          className="lg:hidden text-[#faf9f6] p-1"
          aria-label="Toggle menu"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {open && (
        <div
          data-testid="mobile-menu"
          className="lg:hidden bg-[#151c0f]/97 backdrop-blur-xl border-t border-[#b89d62]/20 mt-3"
        >
          <div className="flex flex-col px-6 py-6 gap-5">
            {NAV_LINKS.map((l) => (
              <button
                key={l.id}
                data-testid={`mobile-nav-link-${l.id}`}
                onClick={() => {
                  scrollTo(l.id);
                  setOpen(false);
                }}
                className="text-left eyebrow !text-[#c9d3ca]"
              >
                {l.label}
              </button>
            ))}
            <a
              href={whatsappLink()}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-2 text-center border border-[#b89d62] text-[#b89d62] px-5 py-3 btn-label"
            >
              Book on WhatsApp
            </a>
          </div>
        </div>
      )}
    </nav>
  );
};
